import { Component } from 'react';
import { Svg } from '../Gauge';
import { formatLabel, formatLabelIdAndId, GaugeCoordinates, GaugeElementId, updateLabelColorById, updateLabelTextById } from '../shared/GaugeShared';

export type valueFn = (value: number) => string;

export interface GaugeCenterLabelProps {
   svg: Svg;
   svgId: string;
   value: number;
   centerLabelColor: string;
   centerLabel: string | valueFn;
   prePendCharacter: string;
   postPendCharacter: string;
}

export class GaugeCenterLabel extends Component<GaugeCenterLabelProps> {
   private CENTER_LABEL_POSITION: GaugeCoordinates = {
      x: 50,
      y: 48
   };
   private CENTER_LABEL_SIZE = 12;
   private CENTER_LABEL_WEIGHT = 'bold';

   constructor(props: GaugeCenterLabelProps) {
      super(props);

      this.drawGaugeCenterLabel(props);
   }

   render(): null {
      return null;
   }

   UNSAFE_componentWillReceiveProps(nextProps: GaugeCenterLabelProps): void {
      this.updateGaugeCenterLabel(nextProps);
   }

   drawGaugeCenterLabel = (props: GaugeCenterLabelProps): void => {
      props.svg.draw.text(this.getCenterLabelIfExists(props))
         .move(this.CENTER_LABEL_POSITION.x, this.CENTER_LABEL_POSITION.y)
         .attr({
                  id: formatLabelIdAndId(GaugeElementId.CENTER_LABEL, props.svgId)
               })
         .font({
                  fill: props.centerLabelColor,
                  size: this.CENTER_LABEL_SIZE,
                  weight: this.CENTER_LABEL_WEIGHT,
                  anchor: 'middle',
                  family: 'sans-serif',
               });
   };

   getCenterLabelIfExists = (props: GaugeCenterLabelProps): string => {
      if (props.centerLabel) {
         let centerLabel;
         if (props.centerLabel instanceof Function) {
            centerLabel = props.centerLabel(props.value);
         }
         else {
            centerLabel = props.centerLabel;
         }
         return formatLabel(centerLabel, props.prePendCharacter, props.postPendCharacter);
      }

      return formatLabel(props.value, props.prePendCharacter, props.postPendCharacter);
   };

   updateGaugeCenterLabel = (props: GaugeCenterLabelProps): void => {
      updateLabelTextById(formatLabelIdAndId(GaugeElementId.CENTER_LABEL, props.svgId), this.getCenterLabelIfExists(props));
      updateLabelColorById(formatLabelIdAndId(GaugeElementId.CENTER_LABEL, props.svgId), props.centerLabelColor);
   };
}
